/**
 * AjaxService
 *
 * Lightweight wrapper around jQuery $.ajax for the standard TMS controller
 * pattern. Always POSTs to ajax.php. The jqXHR is returned so callers can
 * chain .then() / .done() / .fail() on top of the provided callbacks.
 *
 * @example
 * AjaxService.post(
 *     { controller: 'alias', action: 'update', language_text_id: 1, field_text: 'foo' },
 *     (response) => console.log(response),
 *     (jqXHR)    => console.error(jqXHR.responseJSON?.message)
 * ).then((response) => { ... });
 */
class AjaxService {

	/**
	 * POST to ajax.php with the given data payload.
	 *
	 * @param {Object}        data        - Key/value pairs sent as the POST body.
	 * @param {Function|null} [onSuccess] - Called with the parsed response on HTTP 2xx.
	 * @param {Function|null} [onError]   - Called with the jqXHR object on failure.
	 * @returns {jqXHR} jQuery deferred/promise — supports .then(), .done(), .fail().
	 */
	static post(data, onSuccess = null, onError = null) {
		return $.ajax({
			type: 'POST',
			url: 'ajax.php',
			data: data,
			success: function(response) {
				if (typeof onSuccess === 'function') {
					onSuccess(response);
				}
			},
			error: function(jqXHR) {
				if (typeof onError === 'function') {
					onError(jqXHR);
				}
			}
		});
	}
}
